import graphql__66882af2813e6e58dfca from "./__generated__/ConfigurationContractsViewQuery.graphql.ts";import * as React from "react";
import Panel from "./presentational/Panel";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import {usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import {useOutletContext} from "react-router";
import {ConfigurationContractsViewQuery} from "./__generated__/ConfigurationContractsViewQuery.graphql";
import CreateTermsAndConditionsDocumentDialog from "./dialog/CreateTermsAndConditionsDocumentDialog";
import ActionButton from "./presentational/button/ActionButton";
import {faPlusCircle} from "@fortawesome/pro-regular-svg-icons";
import TableHeader from "./presentational/table/TableHeader";
import Table from "./presentational/table/Table";
import TableData from "./presentational/table/TableData";
import Headline from "./presentational/Headline";
import {FormattedDate, useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ConfigurationContractsViewProps = Props & ConnectedProps<typeof connector>;

const ConfigurationContractsView: React.FC<ConfigurationContractsViewProps> = (props) => {
    const intl = useIntl();
    const prepared: any = useOutletContext();

    const {termsAndConditionsDocuments} = usePreloadedQuery<ConfigurationContractsViewQuery>(
        graphql__66882af2813e6e58dfca,
        prepared?.configurationContractsViewQuery,
    );

    const {dispatchShowModal, dispatchHideModal} = props

    // Check if the preloaded query is available
    if (!prepared || !prepared.configurationContractsViewQuery) {
        return (
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.configurationContracts.headline'})}</Headline>
                        </div>
                    </div>
                </div>
                <div className="text-center py-10">
                    <p className="text-gray-500">{intl.formatMessage({id: 'view.configurationContracts.loading'})}</p>
                </div>
            </Panel>
        );
    }
    const showCreateTermsAndConditionsDocumentDialog = () => {
        dispatchShowModal({
            body: (<CreateTermsAndConditionsDocumentDialog handleCloseDialog={dispatchHideModal}/>)
        })
    };

    return (
        <Panel>
            <div className="px-6 pt-6 pb-4">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="flex-1 min-w-0">
                        <Headline>{intl.formatMessage({id: 'view.configurationContracts.headline'})}</Headline>
                    </div>
                    <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                        <ActionButton icon={faPlusCircle} title={intl.formatMessage({id: 'view.configurationContracts.createButton'})} onClick={() => {
                            showCreateTermsAndConditionsDocumentDialog()
                        }}/>
                    </div>
                </div>
            </div>
            {termsAndConditionsDocuments && termsAndConditionsDocuments.edges.length > 0 ? (
                <div className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'view.configurationContracts.ariaLabel'})}>
                    <Table>
                        <thead>
                            <tr>
                                <TableHeader className="hidden sm:table-cell">{intl.formatMessage({id: 'view.configurationContracts.table.id'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationContracts.table.code'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationContracts.table.title'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationContracts.table.version'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationContracts.table.uri'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationContracts.table.startDate'})}</TableHeader>
                            </tr>
                        </thead>
                        <tbody>
                            {termsAndConditionsDocuments.edges.map((edge, index) => {
                                if (!edge.node) {
                                    return null;
                                }
                                const {code, id, title, uri, version} = edge.node;

                                return (
                                    <tr key={index} className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' hover:bg-gray-100 group'}>
                                        <TableData className="hidden sm:table-cell">
                                            <span className="font-mono text-sm">{id}</span>
                                        </TableData>
                                        <TableData>
                                            <span className="font-mono text-sm">{code}</span>
                                        </TableData>
                                        <TableData>{title}</TableData>
                                        <TableData>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                {version}
                                            </span>
                                        </TableData>
                                        <TableData>
                                            <a href={uri} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-900 text-sm">
                                                {uri}
                                            </a>
                                        </TableData>
                                        <TableData>
                                            <FormattedDate value={edge.node.startDate} day="2-digit" month="2-digit" year="numeric"/>
                                        </TableData>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            ) : (
                <div className="text-center py-10">
                    <p className="text-gray-500">{intl.formatMessage({id: 'view.configurationContracts.noDocuments'})}</p>
                </div>
            )}
        </Panel>
    )
}

export default connector(ConfigurationContractsView);
